import {
    NetworkParams,
    RestService,
} from "@sinossi/mates-react-library"

import {
    Brand,
    BrandManagementRequest,
    BrandProfileUpdateRequest,
    Company,
    CreateBrandRequest,
    CreateBrandResponse,
    PaginatedResponse,
    Product,
} from "models"

export class BrandManagementServices
{
    static brandManagementData = (request: BrandManagementRequest, callback: any, catchCallback: any) => {
        RestService
            .post<PaginatedResponse<Brand>>("/api/brands/filter", request)
            .then(callback)
            .catch(catchCallback)
    }

    static getBrand = (brandId: string, callback: any, catchCallback: any) => {
        RestService
            .get<Brand>(`/api/brand/${brandId}`)
            .then(callback)
            .catch(catchCallback)
    }

    static getCompany = (callback: any, catchCallback: any) => {
        RestService
            .post<PaginatedResponse<Company>>(`/api/company`, null)
            .then(callback)
            .catch(catchCallback)
    }

    static createCompany = (body: any, callback: any, catchCallback: any) => {
        RestService
            .post<any>(`/api/company/create`, body)
            .then(callback)
            .catch(catchCallback)
    }

    static getProducts = (callback: any, catchCallback: any) => {
        RestService
            .get<PaginatedResponse<Product>>(`/api/product`)
            .then(callback)
            .catch(catchCallback)
    }

    static createBrand = (body: CreateBrandRequest ,callback: any, catchCallback: any) => {
        RestService
            .post<CreateBrandResponse>(`/api/brand`,body)
            .then(callback)
            .catch(catchCallback)
    }

    static updateBrand = (brandId: string, request: BrandProfileUpdateRequest, callback: any, catchCallback: any) => {
        RestService
            .put(`/api/brand/${brandId}`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static updateLogo = (brandId: string, request: FormData, callback: any, catchCallback: any) => {
        const params = new NetworkParams()
        params.contentType = undefined

        RestService
            .genericPut(`/api/brand/${brandId}/logo`, request, params)
            .then(callback)
            .catch(catchCallback)
    }
}
